module.exports = __webpack_public_path__ + "img/hot-title.5bc65cee.png";